import React from 'react'

export default function ManageEarnings() {
  return (
    <div>
        <h2>Currently No Earnings</h2>
    </div>
  )
}
